// @flow

import { Platform } from 'react-native';

import variable from './../variables/platform';
import { PLATFORM } from './../variables/commonColor';

import Dimensions from "react-native-web-dimension-helper";

const deviceHeight = Dimensions.get('window').height;
export default (variables /* : * */ = variable) => {
  const theme = {
    flex: 1,
    flexBasis: Platform.OS === "web" ? "auto" : undefined,
    height: Platform.OS === PLATFORM.IOS ? deviceHeight : deviceHeight - 20,
    backgroundColor: variables.containerBgColor,
    ".forScroll":{
      flexBasis: Platform.OS === "web" ? "0%" : undefined,
    },
  };

  return theme;
};
